export function getUrlForLocale(url, locale) {
  const supported = ['en', 'de', 'el', 'ar'];

  const safeUrl = typeof url === 'string' ? url : '';

  // Split path/query/hash from provided URL string
  let pathOnly = safeUrl;
  let query = '';
  let fragment = '';

  const hashIndex = pathOnly.indexOf('#');
  if (hashIndex >= 0) {
    fragment = pathOnly.slice(hashIndex);
    pathOnly = pathOnly.slice(0, hashIndex);
  }

  const queryIndex = pathOnly.indexOf('?');
  if (queryIndex >= 0) {
    query = pathOnly.slice(queryIndex);
    pathOnly = pathOnly.slice(0, queryIndex);
  }

  // Normalize leading slash
  const clean = pathOnly.startsWith('/') ? pathOnly.slice(1) : pathOnly;
  const parts = clean.split('/').filter(Boolean);

  // Strip existing locale prefix if present
  if (parts.length && supported.includes(parts[0])) parts.shift();

  const targetLocale = supported.includes(locale) ? locale : 'en';
  const basePath = parts.length ? `/${parts.join('/')}` : '/';

  // English is the canonical root (no prefix)
  const localizedPath =
    targetLocale === 'en'
      ? basePath
      : basePath === '/'
        ? `/${targetLocale}`
        : `/${targetLocale}${basePath}`;

  return `${localizedPath}${query}${fragment}`;
}
